import React, { lazy, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import FleetInfo from './FleetInfo';
import OperatingTerritory from './OpertaingTerritory';
import QuickStats from './QuickStats';
import moment from 'moment';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import Filters from './RadiusFilters';
import { fleetIconMapping, scoreCardItemDescription, columns, severityList, getFleetIno } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));

const Component = ({ Styled, scoreCard, i18n, radiusData, companyId, getVehicles, fetchQuickStatsDetails }) => {
  const [values, setInitialValues] = useState({
    severityId: null,
  });
  const [pagination, setPagination] = useState(false);

  const insuracePortalUserRole = isInsuracePortalUser();

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (radiusData?.radiusViolationDtos) setTableData(radiusData?.radiusViolationDtos);
  }, [radiusData]);

  const generateRows = () => {
    tableData.map((ele) => {
      ele.date = ele.date ? moment(new Date(ele.date)).format('MM/DD/YYYY') : '';
    });
    return tableData;
  };

  const fleetInfo = useMemo(() => {
    return getFleetIno({ i18n, scoreCard, insuracePortalUserRole });
  }, []);

  return (
    <Styled.Wrapper widthOfProgress={90}>
      {fleetInfo.map(({ description, title, value, icon }, index) => (
        <FleetInfo key={index} description={description} title={title} value={value} icon={icon} />
      ))}

      <div className="grid-item left">
        <OperatingTerritory
          iftaStats={scoreCard?.iftaStats}
          radiusOverages={scoreCard?.dailyRadiusStats?.radiusData || []}
          i18n={i18n}
          getVehicles={getVehicles}
          companyId={companyId}
          operatingTerritoryDescription={scoreCardItemDescription.operatingTerritory}
        />
        <QuickStats
          fetchQuickStatsDetails={fetchQuickStatsDetails}
          companyId={companyId}
          quickStatsdescription={scoreCardItemDescription.quickStatus}
          quickStats={scoreCard?.quickStatsData}
          i18n={i18n}
        />
      </div>

      <Tooltip
        mouseEnterDelay={0.5}
        placement="top"
        overlayStyle={{ maxWidth: '300px', opacity: 1 }}
        overlay={<span>{scoreCardItemDescription.fleetManagement || 'NA'}</span>}
      >
        <div className="grid-item right">
          <SubHeader
            variant="h1"
            className="statsHeading"
            text={insuracePortalUserRole ? i18n.t('scoreCard.policyHolderManagement') : i18n.t('scoreCard.fleetManagement')}
          />
          <div class="fleet-details">
            {scoreCard?.fleetStats?.vehicles.map((vehicle) => (
              <>
                <div className="fleet-details-icon">
                  <SvgIcon value={fleetIconMapping[vehicle?.type] ? fleetIconMapping[vehicle?.type] : mediaUrls.bobTail} />
                </div>
                <div className="fleet-details-name">{vehicle?.type}</div>
                <div className="fleet-details-value">{`${vehicle?.count} trucks`}</div>
              </>
            ))}
            {scoreCard?.fleetStats?.trailers.map((trailer) => (
              <>
                <div className="fleet-details-icon">
                  <SvgIcon value={fleetIconMapping[trailer?.type] ? fleetIconMapping[trailer?.type] : mediaUrls.bobTail} />
                </div>
                <div className="fleet-details-name">{trailer?.type}</div>
                <div className="fleet-details-value">{`${trailer?.count} trailers`}</div>
              </>
            ))}
          </div>
        </div>
      </Tooltip>
      <Tooltip
        mouseEnterDelay={0.5}
        placement="top"
        overlayStyle={{ maxWidth: '300px', opacity: 1 }}
        overlay={<span>{scoreCardItemDescription.radiusCompliance || 'NA'}</span>}
      >
        <div className="radius-table">
          <SubHeader variant="h1" className="statsHeading" text={i18n.t('scoreCard.radiusCompliance')} />
          <Styled.TableWrapper>
            <Filters
              severityList={severityList}
              filterList={(data) => {
                setPagination(true);
                if (data.severityId) setTableData(radiusData?.radiusViolationDtos.filter((ele) => ele.severity == data.severityId));
                else setTableData(radiusData?.radiusViolationDtos);
              }}
              handleReset={() => {
                setPagination(true);
                setTableData(radiusData?.radiusViolationDtos);
              }}
              values={values}
              setInitialValues={setInitialValues}
            />

            <Table
              type="client"
              defaultSortBy={{ sortBy: 'date', order: 'desc' }}
              title=""
              columns={[...columns]}
              data={generateRows()}
              emptyMessage={i18n.t('common.tableEmptyMessage')}
              itemsPerPage={5}
              id="dashBoardAlerts"
              setPagination={setPagination}
              pageinationReset={pagination}
              actions={[]}
              i18n={i18n}
            />
          </Styled.TableWrapper>
        </div>
      </Tooltip>
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  scoreCard: PropTypes.object.isRequired,
};
